<div class="grid">
    <div class="main-section">
        <h1>
            {{ "dtmMainPageLib.subpage.eLearning.header" | transloco }}
        </h1>
        <p class="message">
            {{ "dtmMainPageLib.subpage.eLearning.mainMessage" | transloco }}
        </p>
        <div class="main-image mobile">
            <img
                ngSrc="/assets/images/subpages/e-learning-laptop.webp"
                [alt]="'dtmMainPageLib.subpage.eLearning.bannerAltText' | transloco"
                height="853"
                width="1520"
            />
        </div>
        <div class="redirect-button-container desktop">
            <a class="button-primary" [href]="E_LEARNING_URL" target="_blank" rel="noopener noreferrer">{{
                "dtmMainPageLib.subpage.eLearning.redirectLabel" | transloco
            }}</a>
        </div>
    </div>
</div>

<div class="redirect-button-container mobile">
    <a class="button-primary" [href]="E_LEARNING_URL" target="_blank" rel="noopener noreferrer">{{
        "dtmMainPageLib.subpage.eLearning.redirectLabel" | transloco
    }}</a>
</div>

<div class="main-image desktop">
    <img
        ngSrc="/assets/images/subpages/e-learning-laptop.webp"
        [alt]="'dtmMainPageLib.subpage.eLearning.bannerAltText' | transloco"
        dtmUiPageZoomImage
        height="853"
        width="1520"
    />
</div>

<div class="sections-container">
    <div class="grid profits">
        <h2>
            {{ "dtmMainPageLib.subpage.profitsHeader" | transloco }}
        </h2>
        <div class="profits-list">
            <div class="profit">
                <img src="/assets/images/elearning.svg" />
                <div class="profits-info">
                    <p class="title">{{ "dtmMainPageLib.subpage.eLearning.profits.basicsLabel" | transloco }}</p>
                    <p class="message">
                        {{ "dtmMainPageLib.subpage.eLearning.profits.basicsMessage" | transloco : { minAge: MIN_USER_AGE } }}
                    </p>
                </div>
            </div>
            <div class="profit">
                <img src="/assets/images/open-book.svg" />
                <div class="profits-info">
                    <p class="title">{{ "dtmMainPageLib.subpage.eLearning.profits.qualificationsLabel" | transloco }}</p>
                    <p class="message">
                        {{ "dtmMainPageLib.subpage.eLearning.profits.qualificationsMessage" | transloco }}
                    </p>
                </div>
            </div>
            <div class="profit">
                <img src="/assets/images/laptop-user.svg" />
                <div>
                    <p class="title">{{ "dtmMainPageLib.subpage.eLearning.profits.onlineSpeedLabel" | transloco }}</p>
                    <p class="message">
                        {{ "dtmMainPageLib.subpage.eLearning.profits.onlineSpeedMessage" | transloco }}
                    </p>
                </div>
            </div>
            <div class="profit">
                <img src="/assets/images/suitcase.svg" />
                <div>
                    <p class="title">{{ "dtmMainPageLib.subpage.eLearning.profits.developmentLabel" | transloco }}</p>
                    <p class="message">
                        {{ "dtmMainPageLib.subpage.eLearning.profits.developmentMessage" | transloco }}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="dark-background-section">
        <div class="grid">
            <h2>
                {{ "dtmMainPageLib.subpage.possibilitiesHeader" | transloco }}
            </h2>
            <div class="section">
                <div class="image-container trainings-image">
                    <img class="background-blob" src="/assets/images/subpages/blob_4.svg" alt="" />
                    <img
                        class="section-image image-with-box-shadow"
                        src="/assets/images/subpages/e-learning-trainings.webp"
                        [alt]="'dtmMainPageLib.subpage.eLearning.trainingsImageAltText' | transloco"
                        dtmUiPageZoomImage
                    />
                </div>

                <div class="section-info">
                    <h3 class="title">{{ "dtmMainPageLib.subpage.eLearning.trainingsTitle" | transloco }}</h3>
                    <p class="message">
                        {{ "dtmMainPageLib.subpage.eLearning.trainingsMessage" | transloco }}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="grid">
        <div class="section">
            <div class="section-info">
                <h3 class="title">{{ "dtmMainPageLib.subpage.eLearning.quizzesTitle" | transloco }}</h3>
                <p class="message">{{ "dtmMainPageLib.subpage.eLearning.quizzesMessage" | transloco }}</p>
            </div>
            <div class="image-container quizzes-image">
                <img class="background-blob" src="/assets/images/subpages/blob_2.svg" alt="" />
                <img
                    class="section-image image-with-box-shadow"
                    src="/assets/images/subpages/e-learning-quizzes.webp"
                    [alt]="'dtmMainPageLib.subpage.eLearning.quizzesImageAltText' | transloco"
                    dtmUiPageZoomImage
                />
            </div>
        </div>
    </div>
    <div class="dark-background-section">
        <div class="grid">
            <div class="section">
                <div class="image-container exams-image">
                    <img class="background-blob" src="/assets/images/subpages/blob_3.svg" alt="" />
                    <img
                        class="section-image image-with-box-shadow"
                        src="/assets/images/subpages/e-learning-exams.webp"
                        [alt]="'dtmMainPageLib.subpage.eLearning.examsImageAltText' | transloco"
                        dtmUiPageZoomImage
                    />
                </div>
                <div class="section-info">
                    <h3 class="title">{{ "dtmMainPageLib.subpage.eLearning.examsTitle" | transloco }}</h3>
                    <p class="message">{{ "dtmMainPageLib.subpage.eLearning.examsMessage" | transloco }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
